<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Alertas del sistema " />
    <base-material-card color="indigo" icon="mdi-alert" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-col cols="12" sm="2">
          <v-select multiple v-model="tipoFiltro" label="Tipo" :items="$store.state.alertas.tipos" />
        </v-col>
        <v-spacer />
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="alertasList"
        :loading="loading"
        sort-by="fecha"
        sort-desc
      >
        <template v-slot:item.prioridad="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-col cols="6">
              <v-icon v-if="mostrarIconoClose(item)" big class="red--text">mdi-alert</v-icon>
            </v-col>
            <v-col cols="6">
              <v-chip :color="colorPrioridad(item)" text-color="white">{{item.prioridad}}</v-chip>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.historial="{ item }">
          <v-badge overlap :content="item.historial.length" color="primary">
            <v-btn
              depressed
              small
              class="secondary"
              @click="openDialogHistorial(item)"
            >Ver historial</v-btn>
          </v-badge>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="item.prioridad != 3"
                  class="px-2 ml-1"
                  color="success"
                  min-width="0"
                  v-on="on"
                  small
                  @click="marcarSolucionado(item)"
                  :loading="loadingAlerta"
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Marcar solucionado</span>
            </v-tooltip>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog v-model="dialogHistorial" max-width="900">
      <v-card class="mx-auto px-4">
        <v-row justify="center">
          <v-card-title class="mb-4">Historial</v-card-title>
          <v-card-subtitle>Alerta</v-card-subtitle>
          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel v-for="(h,i) in historialComputed" :key="i">
                <v-expansion-panel-header>
                  <v-row no-gutters>
                    <v-col cols="7">{{h && h.mensaje ? h.mensaje : 'sin titulo'}}</v-col>
                    <v-col
                      cols="2"
                      class="text--secondary"
                    >{{h && h.usuario ? h.usuario : 'sin usuario'}}</v-col>
                    <v-col
                      cols="3"
                      class="text--secondary"
                    >{{h && h.fechaMostrar ? h.fechaMostrar: 'sin fecha'}}</v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>{{h && h.adicional ? h.adicional : 'Sin más información'}}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      tipoFiltro: [1, 2],
      loading: false,
      loadingAlerta: false,
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "Prioridad",
          value: "prioridad",
        },
        /*{
          sortable: false,
          text: "Tipo",
          value: "tipo",
        },*/
        {
          sortable: false,
          text: "Última Fecha",
          value: "lastFecha",
        },
        {
          sortable: false,
          text: "Último Mensaje",
          value: "lastMensaje",
        },
        {
          sortable: false,
          text: "Historial",
          value: "historial",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      editedItem: {
        historial: [],
      },
      dialogHistorial: false,
    };
  },
  computed: {
    historialComputed() {
      return this.editedItem.historial
        .map((h) => {
          return {
            ...h,

            fechaMostrar: moment.unix(h.fecha).format("DD-MM-YYYY HH:mm"),
          };
        })
        .sort((a, b) => {
          return b.fecha - a.fecha;
        });
    },
    alertasList() {
      return this.alertasListGetters
        .sort((a, b) => {
          if (a.lastMensaje.includes("cierre")) {
            return -1;
          } else if (b.lastMensaje.includes("cierre")) {
            console.log(b);
            return 1;
          } else {
            return b.lastFechaUnix - a.lastFechaUnix;
          }
        })
        .filter((a) => {
          return this.tipoFiltro.includes(a.prioridad);
        });
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      alertasListGetters: "alertas/getAlertasList",
    }),
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de alertas";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    marcarSolucionado(item) {
      let _vm = this;
      _vm.loadingAlerta = true;
      this.$store
        .dispatch("alertas/marcarSolucionado", item)
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Alerta grabada con éxito",
          });
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la alerta",
          });
        })
        .finally(() => {
          _vm.loadingAlerta = false;
        });
    },
    openDialogHistorial(item) {
      this.editedItem = item;
      this.dialogHistorial = true;
    },
    colorPrioridad(item) {
      switch (item.prioridad) {
        case 1:
          return "red";
          break;
        case 2:
          return "orange";
          break;
        case 3:
          return "green";
          break;
        default:
          return "gray";
      }
    },
    mostrarIconoClose(item) {
      return item.lastMensaje.includes("cierre");
    },
    mostrarIdioma(s) {
      return mostrarIdioma(s);
    },
    reload() {
      this.getAlertas();
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    editItemDialog(item) {},
    getAlertas() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("alertas/getAlertas").finally(() => {
        _vm.loading = false;
      });
    },
    close() {
      this.dialog = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.$store.commit("setLangSeleccionadoDefecto");
    },
    /*save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addCategoria()
            .then(res => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Categoría grabada con éxito"
              });
              _vm.getCategorias();
              _vm.dialog = false;
            })
            .catch(error => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar la categoria"
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    }*/
  },
};
</script>

<style>
</style>